const getProductDetailsForm = state => {
  return state.productDetailsForm;
};

export default {
  getProductDetailsForm,
};
